import { createSvgIcon } from '@automata/mui-theme';
export const AzentaIntelliXcapUncapperIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79.8625 24.4941C80.1419 24.9705 79.9823 25.5832 79.506 25.8627L42.5008 47.5724C41.8879 47.932 41.1301 47.9393 40.5103 47.5916L20.5107 36.3723C20.029 36.1021 19.8576 35.4926 20.1278 35.0109C20.398 34.5292 21.0075 34.3578 21.4892 34.628L41.4888 45.8473L78.4939 24.1376C78.9703 23.8582 79.583 24.0178 79.8625 24.4941Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 82L40 47L42 47L42 82L40 82Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 72.9998L20 61.9998L21.0408 60.292L41.0408 71.292L40 72.9998Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 61.9998L20 50.9998L21.0408 49.292L41.0408 60.292L40 61.9998Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 73.1835V71.1836L33.6195 67.5C33.1412 67.224 32.3658 67.2239 31.8875 67.5L15.8661 76.7493C15.3877 77.0254 15.3877 77.4731 15.8661 77.7493L27.189 84.2861C27.6673 84.5621 28.4427 84.5622 28.921 84.2861L40 77.8901V75.8902L28.0551 82.7861L18.4642 77.2493L32.7533 69L40 73.1835Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.7883 11.5286C59.0065 11.0519 58.0266 11.0407 57.2342 11.4995L20.2474 32.9129C19.4754 33.3599 19 34.1844 19 35.0765V69.9266C19 70.8144 19.4709 71.6356 20.2371 72.0841L22.079 73.1623L25.0689 71.4363L22 69.6399V35.3647L58.4801 14.2447L77.5 25.8421V60.1252L41.0127 80.7693L38.0334 79.0253L35.0436 80.7513L39.7455 83.5037C40.5143 83.9537 41.4643 83.9607 42.2396 83.522L79.2311 62.5926C80.0152 62.149 80.5 61.3177 80.5 60.4167V25.5614C80.5 24.6896 80.0459 23.8808 79.3015 23.4269L59.7883 11.5286Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.7321 46.0001L29.7322 49.3351L37.3098 53.7104L37.3097 50.3753L29.7321 46.0001ZM28.866 43.5C28.3877 43.2239 28 43.4477 28 44L28.0002 49.3351C28.0002 49.8874 28.388 50.5589 28.8662 50.8351L38.1758 56.2104C38.6541 56.4866 39.0418 56.2627 39.0418 55.7104L39.0417 50.3754C39.0416 49.8231 38.6539 49.1515 38.1756 48.8753L28.866 43.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.3614 36.25C41.0788 35.8358 41.0788 35.1642 40.3614 34.75C39.6439 34.3359 38.4807 34.3359 37.7632 34.75C37.0458 35.1642 37.0458 35.8358 37.7632 36.25C38.4807 36.6641 39.6439 36.6641 40.3614 36.25ZM42.0934 37.2499C43.7675 36.2835 43.7675 34.7165 42.0934 33.7501C40.4194 32.7837 37.7052 32.7837 36.0311 33.7501C34.3571 34.7165 34.3571 36.2835 36.0311 37.2499C37.7052 38.2163 40.4194 38.2163 42.0934 37.2499Z"
    />
  </svg>,
  'AzentaIntelliXcapUncapperIcon'
);
